import * as yup from "yup";

export const AddDomainNameSchema = yup.object().shape({
    AddDomainName: yup
    .string()
    .required("Please enter domain name!")
    .matches(
      /^[a-zA-Z0-9][a-zA-Z0-9-_]{0,61}[a-zA-Z0-9]{0,1}\.([a-zA-Z]{1,6}|[a-zA-Z0-9-]{1,30}\.[a-zA-Z]{2,3})$/,
      "Not a valid domain name"
    ),
});
export const EditDomainNameSchema = yup.object().shape({
  EditDomainName: yup
    .string()
    .required("Please enter domain name!")
    .matches(
      /^[a-zA-Z0-9][a-zA-Z0-9-_]{0,61}[a-zA-Z0-9]{0,1}\.([a-zA-Z]{1,6}|[a-zA-Z0-9-]{1,30}\.[a-zA-Z]{2,3})$/,
      "Not a valid domain name"
    ),
});
       